import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home'
import MessageBox from './pages/MessageBox'
import Contact from './pages/Contact'
import Telegram from './pages/Telegram'
import HowToUse from './pages/HowToUse'
import Impressum from './pages/impressum'
import NoPage from './pages/NoPage'
import AppHeader from './components/Navigation';
import AppFooter from './components/Footer.js'
function App() {
   
   

  return (
    <div className="App">     
      <header>
        <AppHeader />        
      </header>            
        <BrowserRouter>
          <Routes>            
            <Route index element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path='/messagebox' element={<MessageBox />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/howtouse' element={<HowToUse />} />
            <Route path='/telegram' element={<Telegram />} />
            <Route path='/impressum' element={<Impressum />} />
            <Route path='*' element={<NoPage />} />
          </Routes>        
        </BrowserRouter>
        <footer>
            <AppFooter />         
        </footer>
        
    </div>
  );
}

export default App;
